import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
    const color = colors;
    const isDark = customization?.navType === 'dark';

    // Token map for the theme builder. Light mode uses the existing scheme;
    // dark mode swaps the surface and text tokens for the SCSS dark variants.
    // Mode-aware tokens (inputBackground, cardShadow, etc.) are also exposed
    // here so component overrides can read them without needing to branch.
    const themeOption = {
        colors: color,
        mode: isDark ? 'dark' : 'light',
        heading: isDark ? color.darkTextTitle : color.grey900,
        paper: isDark ? color.darkPaper : color.paper,
        backgroundDefault: isDark ? color.darkBackground : color.paper,
        background: isDark ? color.darkLevel1 : color.primaryLight,
        darkTextPrimary: isDark ? color.darkTextPrimary : color.grey700,
        darkTextSecondary: isDark ? color.darkTextSecondary : color.grey500,
        textDark: isDark ? color.darkTextTitle : color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: isDark ? color.darkLevel2 : color.secondaryLight,
        divider: isDark ? color.darkLevel1 : color.grey200,

        // Mode-aware component tokens — consumed by compStyleOverride.js.
        inputBackground: isDark ? color.darkLevel1 : color.grey50,
        inputBorder: isDark ? '#475569' : '#94a3b8',
        inputBorderHover: isDark ? '#64748b' : color.primaryMain,
        hoverSurface: isDark ? color.darkLevel2 : color.grey50,
        cardShadow: isDark
            ? '0 4px 24px 0 rgba(0, 0, 0, 0.45)'
            : '0 2px 14px 0 rgba(32, 40, 45, 0.08)',

        customization: { ...customization, navType: isDark ? 'dark' : 'light' },
    };

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;
